import styled from 'styled-components';
import media from 'components/mixins/media';
import { transparentize } from 'utils/color';

const EditableContentWrapper = styled.div`
  background-image: linear-gradient(
    transparent,
    transparent 38px,
    ${props => transparentize(props.theme.colors.textColor, 0.1)} 37px
  );
  background-size: 30px 39px;
  height: 100%;
  min-height: 120px;
  }
  textarea {
    width: 100%;
    background: transparent;
    border: none;
    box-sizing: border-box;
    outline: none;
    font-size: 16px;
    line-height: 39px;
    font-weight: bold;
    color: ${props => props.theme.colors.textColor};
    overflow: hidden;
    resize: none;

    &::placeholder {
      color: ${props => transparentize(props.theme.colors.textColor, 0.5)};
    }

    ${media.mobile`
      padding: 4px 29px 29px 20px;
  `};
  }
`;

export default EditableContentWrapper;
